module.exports = __webpack_public_path__ + "static/image/main/card/image-4.ver2_0_2.png?64e4e860";